import { CampaignSeason, CommissionMemberRole } from "utils/constants";

// The commission must hold exactly one chairman; the rest are regular members.
export const validateCommission = members => {
  if (!members?.length) return "Моля, добавете поне един член на комисията!";

  const chairmen = members.filter(member => member?.role === CommissionMemberRole.Chairman).length;

  if (chairmen === 0) return "Комисията трябва да има Председател!";
  if (chairmen > 1) return "Комисията трябва да има само един Председател!";

  return undefined;
};

// Spring campaigns run for the next academic year, autumn ones for the current.
// The backend does not enforce this, so it is only a prefill - the user may override it.
export const getAcademicYearIdForSeason = (academicYears, season) => {
  const datedYears = academicYears?.filter(year => year?.opensOn && year?.closesOn) ?? [];

  if (!datedYears.length) return undefined;

  const sorted = [...datedYears].sort((a, b) => new Date(a.opensOn) - new Date(b.opensOn));
  const now = new Date();
  const currentIndex = sorted.findIndex(year => new Date(year.opensOn) <= now && now <= new Date(year.closesOn));

  if (currentIndex === -1) return undefined;

  const target = season === CampaignSeason.Spring ? sorted[currentIndex + 1] : sorted[currentIndex];

  return target?.id;
};
